module.exports = __webpack_public_path__ + "static/media/img-fondo-casos-clinicos.421ec3a3.png";